import React, { useEffect, useState } from 'react';
import Modal from '../utils/Modal';
import Api from '../utils/Api';
import Constants from '../constants';

const ReceiveTransaction = (props) => {
    const [bankCVU, setBankCVU] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {    
        filter()
    }, [])

    const filter = () => {
        Api.fetch(Constants.BACKEND_APIS.AccountsCVUs(), 'GET').then(resp => {
            setBankCVU(resp)         
        }).catch(error=> {
            console.log('Error get cvu')
        });
    }

    const createBankCvu = () => {
        setLoading(true)
        Api.fetch(Constants.BACKEND_APIS.AccountsCreateCVU(), 'POST').then(resp => {
            setLoading(false)
            console.log('CVU creado')
            filter()
        }).catch(error => {
            setLoading(false)
            console.log('Error create cvu')
        });
    }

    const copyToClipboard = text => {
        const el = document.createElement('textarea');
        el.value = text;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };

    return (
        <>
            <Modal id='modal-send-transaction' title='Depositar Pesos Argentinos' isOpen={props.isOpen} toggleModal={props.toggleModal} footer={'Esta transaccion es operada por Digipayments SAU'}>  
                { !bankCVU ?
                        <>
                            <div className="mb-6 w-5/6 ml-auto mr-auto flex flex-col text-center items-center ">
                                { loading ?
                                    <div className='w-full h-24 flex '>
                                        <div role="status" className="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
                                            <svg aria-hidden="true" className="w-10 h-10 mr-2 animate-spin text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                    :
                                    <>
                                        <div className='text-white ml-auto mr-auto'>Usted no cuenta con un CVU</div>
                                        <button to="/" className="flex ml-auto mr-auto py-2 p-8 mb-4 mt-8 rounded-full button-action" onClick={createBankCvu}>Obtener CVU</button>
                                    </>
                                }
                            </div>
                        </>
                        :   
                        <>
                            <div className="mb-8 mt-2 w-5/6 ml-auto mr-auto flex flex-row text-center items-center ">
                                <i className='text-white bx bxs-bank bx-lg ml-1' ></i>
                                <div className='text-white ml-2'>Transaferencia Bancaria</div>
                            </div>   
                            <div className="mb-5 w-5/6 ml-auto mr-auto flex flex-col">
                                <label htmlFor="account_name" className="mb-1 block text-sm font-medium color-yellow-orange">Beneficiario</label>
                                <div id='account_name' className="flex flex-row bg-gray-50 text-xs font-bold w-full modal-input border-gray-600 placeholder-gray-400 text-white border-b pb-4">
                                    {bankCVU.account_name}
                                    <button onClick={() => copyToClipboard(bankCVU.account_name)} className='flex ml-auto'>
                                        <i className='bx bx-copy bx-xs'></i>   
                                    </button>
                                </div>
                            </div>
                            <div className="mb-5 w-5/6 ml-auto mr-auto flex flex-col">
                                <label htmlFor="cvu_id" className="mb-1 block text-sm font-medium color-yellow-orange">CVU</label>
                                <div id='cvu_id' className="flex flex-row bg-gray-50 text-xs font-bold w-full modal-input border-gray-600 placeholder-gray-400 text-white border-b pb-4">
                                    {bankCVU.cvu_id}
                                    <button onClick={() => copyToClipboard(bankCVU.cvu_id)} className='flex ml-auto'>
                                        <i className='bx bx-copy bx-xs'></i>   
                                    </button>
                                </div>
                            </div>
                            <div className="mb-5 w-5/6 ml-auto mr-auto flex flex-col">
                                <label htmlFor="cvu_alias" className="mb-1 block text-sm font-medium color-yellow-orange">Alias</label>
                                <div id='cvu_alias' className="flex flex-row bg-gray-50 text-xs font-bold w-full modal-input border-gray-600 placeholder-gray-400 text-white border-b pb-4">
                                    {bankCVU.cvu_alias}
                                    <button onClick={() => copyToClipboard(bankCVU.cvu_alias)} className='flex ml-auto'>
                                        <i className='bx bx-copy bx-xs'></i>   
                                    </button>
                                </div>
                            </div>
                            <div className="mb-5 w-5/6 ml-auto mr-auto flex flex-col">
                                <label htmlFor="email" className="mb-1 block text-sm font-medium color-yellow-orange">Comisión</label>
                                <div className="flex flex-row bg-gray-50 text-xs font-bold w-full modal-input border-gray-600 placeholder-gray-400 text-white border-b pb-4">
                                    0,00 ARS (Sin comisión)
                                </div>
                            </div>
                            <div className="mb-16 w-5/6 ml-auto mr-auto flex flex-col">
                                <label htmlFor="email" className="mb-1 block text-sm font-medium color-yellow-orange">Tiempo</label>
                                <div className="flex flex-row bg-gray-50 text-xs font-bold w-full modal-input border-gray-600 placeholder-gray-400 text-white border-b pb-4">
                                    Inmediata
                                </div>
                            </div>
                        </>
                }
            </Modal>
        </>
    )
}

export default ReceiveTransaction;